import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const SelectLogo = ({ logos, onChange, value }) => {
  const [selectedLogo, setSelectedLogo] = useState(null);

  // Map logos to options format compatible with react-select
  const options = logos.map((logo) => ({
    value: logo.id,
    label: logo.company_name,
    image: `https://filmconnx-production.s3.amazonaws.com/uploads/${logo.image}`,
  }));

  // Custom styles for react-select dropdown to show logos
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
    }),
  };

  // Custom option component to display logo images in the dropdown
  const formatOptionLabel = ({ label, image }) => (
    <div className="flex items-center">
      <img src={image} alt={label} className="w-6 h-6 rounded-full mr-2" />
      {label}
    </div>
  );

  const handleSelection = (selectedOption) => {
    setSelectedLogo(selectedOption);
    console.log('Selected Option Id ', selectedOption);
    const selection = logos.find((logo) => logo.id === selectedOption.value)
    console.log('What is the Selection ', selection);
    onChange(selection);  // Pass the selected logo back to the parent component
  };

  // Set the initial selection based on the value passed in
  useEffect(() => {
    if (value) {
      const initialSelection = options.find(option => option.value === value.id);
      if(initialSelection){
        setSelectedLogo(initialSelection);
      }
    }
  }, [value]);

  return (
    <div className="w-full">
      <label className="block text-gray-700 text-sm font-bold mb-2">
        Select a Logo
      </label>
      <Select
        options={options}
        styles={customStyles}
        formatOptionLabel={formatOptionLabel}
        value={selectedLogo}
        onChange={handleSelection}
        placeholder="Search for a company"
        isSearchable={true}  // Enable searching
      />

      {/* Display the selected logo image */}
      {selectedLogo && (
        <div className="mt-4">
          <img src={selectedLogo.image} alt={selectedLogo.label} className="w-24 h-24 object-contain mx-auto" />
          <p className="text-center mt-2">{selectedLogo.label}</p>
        </div>
      )}
    </div>
  );
};

export default SelectLogo;
